import { WorkflowTrigger } from '@frontend/workflow/types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export enum UserTriggerName {
    USER_ACCESS_KEY_SCANNED = 'user_access_key_scanned',
    USER_BADGE_SCANNED = 'user_badge_scanned',
    USER_ITSME_AUTHENTICATED = 'user_itsme_authenticated',
    USER_STATE_CHANGED = 'user_state_changed'
}

export class UserTrigger extends WorkflowTrigger {
    static readonly USER_ACCESS_KEY_SCANNED = new UserTrigger(
        UserTriggerName.USER_ACCESS_KEY_SCANNED,
        (
            <FormattedMessage
                id='UserTrigger.user_access_key_scanned'
                description='The displayed value for the UserTrigger user_access_key_scanned'
                defaultMessage='Access key scanned'
            />
        )
    );

    static readonly USER_BADGE_SCANNED = new UserTrigger(
        UserTriggerName.USER_BADGE_SCANNED,
        (
            <FormattedMessage
                id='UserTrigger.user_badge_scanned'
                description='The displayed value for the UserTrigger user_badge_scanned'
                defaultMessage='Badge scanned'
            />
        )
    );

    static readonly USER_ITSME_AUTHENTICATED = new UserTrigger(
        UserTriggerName.USER_ITSME_AUTHENTICATED,
        (
            <FormattedMessage
                id='UserTrigger.user_itsme_authenticated'
                description='The displayed value for the UserTrigger user_itsme_authenticated'
                defaultMessage='Itsme authenticated'
            />
        )
    );

    static readonly USER_STATE_CHANGED = new UserTrigger(
        UserTriggerName.USER_STATE_CHANGED,
        (
            <FormattedMessage
                id='UserTrigger.user_state_changed'
                description='The displayed value for the UserTrigger user_state_changed'
                defaultMessage='State changed'
            />
        )
    );

    static override readonly ALL = [
        UserTrigger.USER_ACCESS_KEY_SCANNED,
        UserTrigger.USER_BADGE_SCANNED,
        UserTrigger.USER_ITSME_AUTHENTICATED,
        UserTrigger.USER_STATE_CHANGED,
        ...super.ALL
    ];

    static override getByValue(trigger: string): UserTrigger | WorkflowTrigger | undefined {
        return this.ALL.find((t) => t.value === trigger);
    }
}
